import {exposeWidget, init} from '@common/widget-api/utils';
import {WidgetProps} from './Widget';

const WIDGET_ID = 'TmtSiirtymaModaali';
const TRANSITIONAL_MODAL_SHOWN = 'TRANSITIONAL_MODAL_4_0_SHOWN';

const debugMode = location.search.includes('SHOW_TMTSIIRTYMAMODAALI');

const shouldShowModal = (key: string) =>
  localStorage.getItem(key || TRANSITIONAL_MODAL_SHOWN) !== 'true';

const setModalShown = (key: string) =>
  localStorage.setItem(key || TRANSITIONAL_MODAL_SHOWN, 'true');

const loadWidget = async () => {
  const widgetEntrypoint = await import(
    '@common/widget-api/widgetEntrypoint'
  ).then(module => module.default);
  const Widget = await import('./Widget').then(module => module.default);

  widgetEntrypoint(WIDGET_ID, Widget);
};

exposeWidget(WIDGET_ID, {
  render: (_props: WidgetProps) => {
    const KEY = TRANSITIONAL_MODAL_SHOWN;

    if (shouldShowModal(KEY) || debugMode) {
      loadWidget();
      setModalShown(KEY);
    }
  },
  unmount: () => {}
});

init(WIDGET_ID, true);
